import React from 'react';

const LocalEncryptionInfoSection = () => (
  <div className="local-encryption-info">
    <div className="local-encryption-title">Protection locale du navigateur</div>
    <div className="local-encryption-text">
      Vos clés API et données sensibles sont également chiffrées localement dans le navigateur pour éviter toute exposition accidentelle en clair.
    </div>
    <div
      className="local-encryption-note"
      title="Les clés API ne quittent jamais votre appareil. Elles sont stockées de façon sécurisée et ne sont jamais transmises en clair."
    >
      En savoir plus
    </div>
  </div>
);

export default LocalEncryptionInfoSection;
